// Official Boreal Coco logo (background removed). variant="white" for dark surfaces.
export const Logo = ({ variant = "color", className = "" }) => (
  <img
    src={variant === "white" ? "/logo-white.png" : "/logo-color.png"}
    alt="Boreal Coco"
    data-testid="brand-logo"
    className={`h-12 md:h-14 w-auto object-contain ${className}`}
  />
);
